import tableResponsiveComponent from './table-responsive.component';

const tableResponsiveModule = angular
  .module('tableResponsiveModule',[])
  .component('tableResponsive', tableResponsiveComponent);

export default tableResponsiveModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/table-responsive/table-responsive.js
 **/